module.exports = __webpack_public_path__ + "fonts/ef60fd5a651f2b1d829be5269653ba86.eot";